import React from 'react';
import styled from 'styled-components';
import {LazyLoadImage} from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import {getThumbnailPath} from "@models/property";
import ConvertPixelToRem from "@helpers/convert.rem";
import Icon from "@atoms/icon";
import {time_ago, isEmpty} from "@helpers/helpers";
import {getPropertyUrl, getPropertyVideoPath, handleTitle} from "../helpers/property_helpers";
import TransactionIcon from "@icons/transaction.svg";
import {PropertyImageCustomTag, VideoIframeCard} from "../components/card.image";
import MediaItems from "../components/media_items";

function GridCardImage({property, className, imgCount, videoCount, selectedCityFilter, handleShowProperty, isBadeSaba}) {
    const {boosted_at} = property;
    const videoPath = getPropertyVideoPath(property);

    return (
        <Card className={(className ?? '') + ((videoPath && !isEmpty(property) && !property.archived) ? ' has-video ' : '')}>

            <Medias className="d-flex align-items-center">
                <MediaItems img_count={imgCount} video_count={videoCount}/>
            </Medias>


            <PropertyImageCustomTag
                is_link={isEmpty(videoPath)}
                getPropertyUrl={getPropertyUrl}
                property={property}
                isBadeSaba={isBadeSaba}
                handleShowProperty={handleShowProperty}
                item_count={(imgCount + videoCount)}
            >
                <Image className={"position-relative cursor-pointer " + (property.archived ? 'is-archived' : '')}>

                    {
                        (videoPath && !isEmpty(property) && !property.archived) ?
                            <VideoIframeCard className="">
                                <span style={{display: 'block', paddingTop: '57%'}}/>
                                <iframe src={videoPath} allowFullScreen="true" webkitallowfullscreen="true"
                                        mozallowfullscreen="true"/>
                            </VideoIframeCard>
                            :
                            <LazyLoadImage
                                src={getThumbnailPath(property, null, null, true)}
                                effect="blur"
                                height="100%"
                                width="100%"
                                alt={handleTitle(property, false, selectedCityFilter, null, true)}/>
                    }

                    {
                        (!isEmpty(property) && property.archived) ?
                            <div className="is-archived w-100 h-100 rounded-8 bg-gray100 d-flex flex-column align-items-center justify-content-center">
                                <Icon width={56}><TransactionIcon/></Icon>
                                <span className="text-primary h4-normal mt-8">ملک آرشیوی</span>
                            </div>
                            :
                            ''
                    }
                </Image>
            </PropertyImageCustomTag>

            {
                (!property.archived && isEmpty(videoPath)) ?
                    <React.Fragment>
                        <FooterContainer className={(imgCount > 0 ? 'has-media' : '')}>
                            <Footer className="d-flex justify-content-center align-items-center">
                                <Time className={((imgCount > 0) ? 'text-white' : '')}>{time_ago(boosted_at, '6_month')}</Time>
                            </Footer>
                        </FooterContainer>
                    </React.Fragment>
                    : ''
            }
        </Card>
    );
}

export default React.memo(GridCardImage)

// *********
// styles
// *********

const Card = styled.div`
  position: relative;
  width: 200px;
  height: 130px;
  object-fit: contain;
  border-radius: 8px;
  background-color: ${props => props.theme.gray100};

  @media (max-width: ${props => props.theme.screenXsMax}) {
    width: 120px;
    height: 120px;
  }
`;

export const Image = styled.div`
  width: 100%;
  height: 100%;
  background-color: ${props => props.theme.gray250};
  border-radius: 8px;

  img {
    background-color: ${props => props.theme.gray250};
    border-radius: 8px;
    width: 100%;
    height: 100%;
    overflow: hidden;
    -o-object-fit: cover;
    object-fit: cover;
    -o-object-position: 50% 50%;
    object-position: 50% 50%;
  }

  .is-archived {
    position: absolute;
    top: 0;
    left: 0;
  }
`;


export const Time = styled.time`
  color: ${props => props.theme.black};
  font-size: ${ConvertPixelToRem(11)};
  font-weight: normal;
  line-height: 1.58;
`;


export const FooterContainer = styled.div`
  position: absolute;
  width: 100%;
  height: 70%;
  bottom: 0;
  right: 0;
  left: 0;
  cursor: pointer;
  border-radius: 0 0 8px 8px;

  &.has-media {
    box-shadow: rgba(0, 0, 0, 0.6) 0px -80px 50px -50px inset;

    ${Time} {
      color: ${props => props.theme.white};
    }
  }
`;

export const Footer = styled.div`
  position: absolute;
  //right: 16px;
  left: 8px;
  bottom: 5px;
  color: ${props => props.theme.white};

  .media-box {
    svg {
      path, g {
        stroke: #ffffff;
        stroke-width: 1.2;
      }
    }

    .just-video {
      svg {
        path, g {
          stroke: ${props => props.theme.black};
        }
      }
    }
  }
`;

const Medias = styled.div`
  position: absolute;
  top: 8px;
  left: 8px;
  color: #ffffff;
  z-index: 2;

  svg {
    path, g {
      stroke: #ffffff;
      stroke-width: 1.2;
    }
  }
`;